import TenantPage from 'layouts/TenantPage';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import { ITransportDocument } from '../../types';
import TransportDocumentForm from '../components/form/TransportDocumentForm';
import { transportDocumentService } from '../api/transport-document.service';

const initDdt: ITransportDocument = {
  id: null,
  ref: '',
  invoice_ref: '',
  closed: false,
  amount: 0,
  shipping_fare: 0
};

export const CreateTransportDocument = () => {
  const translationPrefix = 'pages.ddt.new';

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onSubmit = async (values) => {
    dispatch(loadingActions.startLoading());
    transportDocumentService.add(values).then((res) => {
      if (res?.id) {
        enqueueSnackbar('DDT aggiunto con successo', { variant: 'success' });
        navigate(`../${res.id}`);
      }
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <TransportDocumentForm transport_document={initDdt} onSubmit={onSubmit} />
    </TenantPage>
  );
};

export default CreateTransportDocument;
